/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1727
 */

"use strict"

var r = require(/* 86 */"./1650/86/index")
var /* [auto-meaningful-name] */require_761_$_1648_761_index$start = require(/* 761 */"./1648/761/index").start
var i = require(/* 1099 */"./1725/1099")("trimStart")
var a = i ? function () {
  return require_761_$_1648_761_index$start(this)
} : "".trimStart
r({
  target: "String",
  proto: true,
  forced: i
}, {
  trimStart: a,
  trimLeft: a
})
